import { render, staticRenderFns } from "./FigmaVectorLayer.vue?vue&type=template&id=229f614d&scoped=true"
import script from "./FigmaVectorLayer.vue?vue&type=script&lang=js"
export * from "./FigmaVectorLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f614d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229f614d')) {
      api.createRecord('229f614d', component.options)
    } else {
      api.reload('229f614d', component.options)
    }
    module.hot.accept("./FigmaVectorLayer.vue?vue&type=template&id=229f614d&scoped=true", function () {
      api.rerender('229f614d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/layers/FigmaVectorLayer.vue"
export default component.exports